import Offcanvas from 'react-bootstrap/Offcanvas';
import './../css/GPage2.css';
import './../css/GPage3.css';
import './../css/Gtop.css';
import './../css/GStyle.css';
import './../css/GCandidates.css';
import './../css/GAnimetion.css';
import GCandGridCardLeftSidebar from './GCandGridCardLeftSidebar';

import GCandGridCard from './GCandGridCard';
import 'bootstrap/dist/css/bootstrap.min.css';
import GHeader from './GHeader';
import GFooter from './GFooter';

import GSignImg from './GSignImg';
import { systemConfiguration, includeScripts, includeBootstrapCss, includeBundleBootstrapCss, Properties } from '../../CommonImports';
import { useEffect } from '../../InBuildImports';
import GJobsHubMenu from './GJobsHubMenu';


function GCandidatesgrid() {
    const sasToken = systemConfiguration.AZURE_FTP_GRASTECH3JOBS_SAAS_TOKEN;
    const mediaUrl = 'https://grastechftp.blob.core.windows.net/grastech3jobs/media/icons/';

    useEffect(() => {
        includeBootstrapCss();
        includeBundleBootstrapCss();
        includeScripts();
        document.addEventListener("DOMContentLoaded", function () {
            if (window.innerWidth >= 992) {
                const sidebar = Offcanvas(document.getElementById(Properties.SIDEBAR_MENU_PROP));
                sidebar.show();
            }
        });
    }, []);


    return (
        <div>
            <GHeader />
            <GJobsHubMenu />
            <section className="section-box-2">
                <div className="box-head-single none-bg">
                    <div className="container">
                        <h4>There Are 968 Candidates<br />Here For You!</h4>
                        <div className="row mt-15 mb-40">
                            <div className="col-lg-7 col-md-9">
                                <span className="text-mutted">Discover your next career move, freelance gig, or
                                    internship</span>
                            </div>
                            <div className="col-lg-5 col-md-3 text-lg-end text-start">
                                <ul className="breadcrumbs mt-sm-15">
                                    <li><a href="#">Home</a></li>
                                    <li>Candidates listing</li>
                                </ul>
                            </div>
                        </div>
                        <div className="box-shadow-bdrd-15 box-filters">
                            <div className="row">
                                <div className="col-lg-5">
                                    <div className="box-search-job">
                                        <form className="form-search-job">
                                            <input type="text" className="input-search-job" placeholder="UI Designer" />
                                        </form>
                                    </div>
                                    {/* <div className="list-tags-job">
                                    <a href="#" className="text-normal job-tag">UI/UX designing <span className="remove-tags-job"></span></a>
                                </div>  */}
                                </div>
                                <div className="col-lg-7">
                                    <div className="d-flex job-fillter">
                                        <div className="d-block d-lg-flex">
                                            <div className="dropdown job-type">
                                                <button className="btn dropdown-toggle" type="button" id="dropdownJobType"
                                                    data-bs-toggle="dropdown" aria-expanded="false" aria-haspopup="true"
                                                    data-bs-display="static"><i className="bi bi-briefcase"></i>
                                                    <span>Full time</span> <i className="fi-rr-angle-small-down"></i></button>
                                                <ul className="dropdown-menu" aria-labelledby="dropdownJobType">
                                                    <li><a className="dropdown-item active" href="#">Full time</a></li>
                                                    <li><a className="dropdown-item" href="#">Part time</a></li>
                                                    <li><a className="dropdown-item" href="#">Freelancer</a></li>
                                                    <li><a className="dropdown-item" href="#">Online work</a></li>
                                                </ul>
                                            </div>
                                            <div className="dropdown">
                                                <button className="btn dropdown-toggle" type="button" id="dropdownLocation"
                                                    data-bs-toggle="dropdown" aria-expanded="false"
                                                    data-bs-display="static"><i className="fi-rr-marker"></i> <span>New
                                                        York, USA</span> <i className="fi-rr-angle-small-down"></i></button>
                                                <ul className="dropdown-menu" aria-labelledby="dropdownLocation">
                                                    <li><a className="dropdown-item active" href="#">New York, USA</a></li>
                                                    <li><a className="dropdown-item" href="#">Dallas, USA</a></li>
                                                    <li><a className="dropdown-item" href="#">Chicago, USA</a></li>
                                                </ul>
                                            </div>
                                            <div className="dropdown">
                                                <button className="btn dropdown-toggle" type="button" id="dropdownLocation2"
                                                    data-bs-toggle="dropdown" aria-expanded="false"
                                                    data-bs-display="static"><i className="fi-rr-dollar"></i> <span>Salary
                                                        Range</span> <i className="fi-rr-angle-small-down"></i></button>
                                                <ul className="dropdown-menu" aria-labelledby="dropdownLocation2">
                                                    <li><a className="dropdown-item active" href="#">$100 - $500</a></li>
                                                    <li><a className="dropdown-item" href="#">$500 - $1000</a></li>
                                                    <li><a className="dropdown-item" href="#">$1000 - $1500</a></li>
                                                    <li><a className="dropdown-item" href="#">$1500 - $2000</a></li>
                                                    <li><a className="dropdown-item" href="#">Over $2000</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="box-button-find">
                                            <button className="btn btn-default">Find Now</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="section-box mt-80">
                <div className="container">
                    <div className="row flex-row-reverse">
                        <div className="col-lg-9 col-md-12 col-sm-12 col-12 float-right">
                            <div className="content-page">
                                <div className="box-filters-job mt-15 mb-10">
                                    <div className="row">
                                        <div className="col-lg-7">
                                            <span className="text-small">Showing <strong>41-60 </strong>of <strong>944
                                            </strong>Candidates</span>
                                        </div>
                                        <div className="col-lg-5 text-lg-end mt-sm-15">
                                            <div className="display-flex2">
                                                <span className="text-sortby">Sort by:</span>
                                                <div className="dropdown dropdown-sort">
                                                    <button className="btn dropdown-toggle" type="button" id="dropdownSort"
                                                        data-bs-toggle="dropdown" aria-expanded="false"
                                                        data-bs-display="static"><span>Newest Post</span> <i
                                                            className="fi-rr-angle-small-down"></i></button>
                                                    <ul className="dropdown-menu dropdown-menu-light"
                                                        aria-labelledby="dropdownSort">
                                                        <li><a className="dropdown-item active" href="#">Newest Post</a></li>
                                                        <li><a className="dropdown-item" href="#">Oldest Post</a></li>
                                                        <li><a className="dropdown-item" href="#">Rating Post</a></li>
                                                    </ul>
                                                </div>
                                                <div className="box-view-type">
                                                    <a href="candidates-list.html" className="view-type">
                                                        <img src={mediaUrl + 'icon-list.svg?' + sasToken} alt="jobhub" /></a>
                                                    <a href="candidates-grid.html" className="view-type">
                                                        <img src={mediaUrl + 'icon-grid.svg?' + sasToken} alt="jobhub" /></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                < GCandGridCard />


                                <div className="paginations">
                                    <ul className="pager">
                                        <li><a href="#" className="pager-prev"></a></li>
                                        <li><a href="#" className="pager-number">1</a></li>
                                        <li><a href="#" className="pager-number">2</a></li>
                                        <li><a href="#" className="pager-number">3</a></li>
                                        <li><a href="#" className="pager-number">4</a></li>
                                        <li><a href="#" className="pager-number">5</a></li>
                                        <li><a href="#" className="pager-number active">6</a></li>
                                        <li><a href="#" className="pager-number">7</a></li>
                                        <li><a href="#" className="pager-next"></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <GCandGridCardLeftSidebar/>
                        {/* <div className="col-lg-3 col-md-12 col-sm-12">

                            <div className="bg-light p-4 rounded mb-4">
                                <h5 className="fw-semibold mb-3">Set Job Reminder</h5>
                                <p className="text-muted">Enter your email address and get job notification.</p>
                                <form>
                                    <div className="mb-3 position-relative">
                                        <input type="email" className="form-control ps-5" placeholder="Enter email address" />
                                        <i className="fi fi-rr-envelope position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
                                    </div>
                                    <button type="submit" className="btn btn-primary w-100">Submit</button>
                                </form>
                            </div>


                            <div className="bg-white shadow-sm p-4 border rounded mb-4">

                                <div className="mb-4">
                                    <h5 className="fw-semibold mb-3">Location</h5>
                                    <div className="position-relative">
                                        <input type="text" className="form-control ps-5" placeholder="Location" />
                                        <i className="fi fi-rr-marker position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
                                    </div>
                                </div>


                                <div className="mb-4">
                                    <h5 className="fw-semibold mb-3">Category</h5>
                                    <div className="position-relative">
                                        <select className="form-select ps-5">
                                            <option selected>UI/UX Design</option>
                                            <option>UI/UX Design 1</option>
                                            <option>UI/UX Design 2</option>
                                            <option>UI/UX Design 3</option>
                                        </select>
                                        <i className="fi fi-rr-briefcase position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
                                    </div>
                                </div>


                                <div className="mb-4">
                                    <h5 className="fw-semibold mb-3">Job Type</h5>
                                    <ul className="list-unstyled">
                                        <li className="d-flex justify-content-between align-items-center mb-2">
                                            <div className="form-check">
                                                <input className="form-check-input" type="checkbox" />
                                                <label className="form-check-label">Full Time Jobs</label>
                                            </div>
                                            <span className="badge bg-light text-dark">235</span>
                                        </li>
                                        <li className="d-flex justify-content-between align-items-center mb-2">
                                            <div className="form-check">
                                                <input className="form-check-input" type="checkbox" checked />
                                                <label className="form-check-label">Part Time Jobs</label>
                                            </div>
                                            <span className="badge bg-light text-dark">28</span>
                                        </li>
                                        <li className="d-flex justify-content-between align-items-center mb-2">
                                            <div className="form-check">
                                                <input className="form-check-input" type="checkbox" checked />
                                                <label className="form-check-label">Remote Jobs</label>
                                            </div>
                                            <span className="badge bg-light text-dark">67</span>
                                        </li>
                                        <li className="d-flex justify-content-between align-items-center mb-2">
                                            <div className="form-check">
                                                <input className="form-check-input" type="checkbox" />
                                                <label className="form-check-label">Freelance</label>
                                            </div>
                                            <span className="badge bg-light text-dark">92</span>
                                        </li>
                                        <li className="d-flex justify-content-between align-items-center">
                                            <div className="form-check">
                                                <input className="form-check-input" type="checkbox" />
                                                <label className="form-check-label">Temporary</label>
                                            </div>
                                            <span className="badge bg-light text-dark">14</span>
                                        </li>
                                    </ul>
                                </div>


                                <div className="mb-4">
                                    <h5 className="fw-semibold mb-3">Experience Level</h5>
                                    <ul className="list-unstyled">
                                        <li className="d-flex justify-content-between align-items-center mb-2">
                                            <div className="form-check">
                                                <input className="form-check-input" type="checkbox" />
                                                <label className="form-check-label">Expert</label>
                                            </div>
                                            <span className="badge bg-light text-dark">76</span>
                                        </li>
                                        <li className="d-flex justify-content-between align-items-center mb-2">
                                            <div className="form-check">
                                                <input className="form-check-input" type="checkbox" />
                                                <label className="form-check-label">Senior</label>
                                            </div>
                                            <span className="badge bg-light text-dark">89</span>
                                        </li>
                                        <li className="d-flex justify-content-between align-items-center mb-2">
                                            <div className="form-check">
                                                <input className="form-check-input" type="checkbox" checked />
                                                <label className="form-check-label">Junior</label>
                                            </div>
                                            <span className="badge bg-light text-dark">54</span>
                                        </li>
                                        <li className="d-flex justify-content-between align-items-center mb-2">
                                            <div className="form-check">
                                                <input className="form-check-input" type="checkbox" checked />
                                                <label className="form-check-label">Regular</label>
                                            </div>
                                            <span className="badge bg-light text-dark">23</span>
                                        </li>
                                        <li className="d-flex justify-content-between align-items-center mb-2">
                                            <div className="form-check">
                                                <input className="form-check-input" type="checkbox" />
                                                <label className="form-check-label">Internship</label>
                                            </div>
                                            <span className="badge bg-light text-dark">22</span>
                                        </li>
                                        <li className="d-flex justify-content-between align-items-center">
                                            <div className="form-check">
                                                <input className="form-check-input" type="checkbox" />
                                                <label className="form-check-label">Associate</label>
                                            </div>
                                            <span className="badge bg-light text-dark">14</span>
                                        </li>
                                    </ul>
                                </div>


                                <div className="mb-4">
                                    <h5 className="fw-semibold mb-3">Salary Range</h5>

                                    <div className="row g-2">
                                        <div className="col-6">
                                            <label className="form-label">From</label>
                                            <input type="text" className="form-control" value="$1500" disabled />
                                        </div>
                                        <div className="col-6">
                                            <label className="form-label">To</label>
                                            <input type="text" className="form-control" value="$60000" disabled />
                                        </div>
                                    </div>
                                </div>


                                <div className="d-flex gap-2">
                                    <button className="btn btn-primary w-50">Apply Filter</button>
                                    <button className="btn btn-outline-secondary w-50">Reset Filter</button>
                                </div>
                            </div>


                            <div className="bg-primary text-white p-4 rounded">
                                <h5 className="fw-semibold mb-3">Recruiting?</h5>
                                <p className="text-white mb-4">Advertise your jobs to millions of monthly users and search 16.8 million CVs in our database.</p>
                                <a href="#" className="btn btn-outline-light w-100">Post a Job</a>
                            </div>
                        </div> */}

                    </div>
                </div>
            </section>

            <div className="section-box py-5">
                <div className="container px-4 px-lg-5">

                    <div className="row justify-content-center mb-4">
                        <div className="col-6 col-sm-3 col-md-2 text-center hover-up">
                            <img src={mediaUrl + "samsung.svg?" + sasToken} className="img-fluid hover-opacity animate__animated animate__fadeInUp" />

                        </div>
                        <div className="col-6 col-sm-3 col-md-2 text-center hover-up">
                            <a href="#"><img src={mediaUrl + "google_002.svg?" + sasToken} alt="Google" className="img-fluid hover-opacity" /></a>
                        </div>
                        <div className="col-6 col-sm-3 col-md-2 text-center hover-up">
                            <a href="#"><img src={mediaUrl + "faceboook.svg?" + sasToken} alt="Facebook" className="img-fluid hover-opacity" /></a>
                        </div>
                        <div className="col-6 col-sm-3 col-md-2 text-center hover-up">
                            <a href="#"><img src={mediaUrl + "pinterest.svg?" + sasToken} alt="Pinterest" className="img-fluid hover-opacity" /></a>
                        </div>
                    </div>


                    <div className="row justify-content-center mb-4">
                        <div className="col-6 col-sm-3 col-md-2 text-center hover-up">
                            <a href="#"><img src={mediaUrl + "avaya.svg?" + sasToken} alt="Avaya" className="img-fluid hover-opacity" /></a>
                        </div>
                        <div className="col-6 col-sm-3 col-md-2 text-center hover-up">
                            <a href="#"><img src={mediaUrl + "forbes.svg?" + sasToken} alt="Forbes" className="img-fluid hover-opacity" /></a>
                        </div>
                        <div className="col-6 col-sm-3 col-md-2 text-center hover-up">
                            <a href="#"><img src={mediaUrl + "avis.svg?" + sasToken} alt="Avis" className="img-fluid hover-opacity" /></a>
                        </div>
                        <div className="col-6 col-sm-3 col-md-2 text-center hover-up">
                            <a href="#"><img src={mediaUrl + "nielsen.svg?" + sasToken} alt="Nielsen" className="img-fluid hover-opacity" /></a>
                        </div>
                    </div>


                    <div className="row justify-content-center">
                        <div className="col-6 col-sm-3 col-md-2 text-center hover-up">
                            <a href="#"><img src={mediaUrl + "doordash.svg?" + sasToken} alt="DoorDash" className="img-fluid hover-opacity" /></a>
                        </div>
                    </div>
                </div>
            </div>


            <section className="section-box my-5">
                <GSignImg />
            </section>
            <GFooter />
        </div>
    );
}
export default GCandidatesgrid;